import {
  Button,
  Paper,
  styled,
  Typography,
  TableCell,
} from "@material-ui/core";

export const DarkBlue = "#0d335d";

export const DarkRed = "#c70039";

export const DialogDeleteButton = styled(Button)({
  color: "white",
  backgroundColor: "#c70039",
  marginTop: 5,
  marginLeft: 7,

  "&:hover": {
    background: " #ffcccc",
    marginTop: 5,
    marginLeft: 7,
  },
});

export const PrimaryButton = styled(Button)({
  color: "white",
  backgroundColor: "#3172B4",
  borderRadius: 3,

  "&:hover": {
    background: "#3172B499",
    borderRadius: 3,
  },
});

export const DeleteAllButton = styled(Button)({
  color: "white",
  backgroundColor: "#c70039",
  borderRadius: 3,
  marginBottom: 30,
  marginTop: 31,
  marginLeft: 10,

  "&:hover": {
    background: "#ffcccc",
    borderRadius: 3,
    marginBottom: 30,
    marginTop: 31,
    marginLeft: 10,
  },
});

export const TableCellContent = styled(TableCell)({
  fontSize: 15,
});

export const TableCellTadpole = styled(TableCell)({
  color: "black",
  fontWeight: "bold",
  fontSize: 20,
  width: "auto",
  marginRight: 20,
});

export const SecondaryButton = styled(Button)({
  color: "white",
  backgroundColor: "#3172B4",
  borderRadius: 3,
  width: 150,
  marginBottom: 10,

  "&:hover": {
    width: 150,
    background: "#3172B499",
    borderRadius: 3,
    marginBottom: 10,
  },
});

export const CopyButton = styled(Button)({
  color: "white",
  backgroundColor: "#3172B4",
  borderRadius: 3,
  paddingLeft: 10,
  marginBottom: 10,
  marginTop: 10,

  "&:hover": {
    background: "#3172B499",
    borderRadius: 3,
    paddingLeft: 10,
    marginBottom: 10,
  },
});

export const DialogCancelButton = styled(Button)({
  backgroundColor: "#dddddd",
  marginTop: 5,

  "&:hover": {
    background: "#bfbfbf",
    marginTop: 5,
  },
});

export const DialogButton = styled(Button)({
  backgroundColor: "#3172B4",
  color: "white",
  marginTop: 5,
  marginLeft: 5,

  "&:hover": {
    background: "#3172B499",
    marginTop: 5,
    marginLeft: 5,
  },
});

export const LoadPaper = styled(Paper)({
  marginTop: 40,
  width: 300,
  gridRow: "1",
  textAlign: "center",
  height: "100%",
});

export const PaperTitle = styled(Typography)({
  marginTop: 10,
  fontWeight: 650,
  fontSize: 20,
});

export const HeaderTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: 24,
});

export const PageTitle = styled(Typography)({
  color: "white",
  fontWeight: 700,
  fontSize: 36,
});
